import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
    ApiErrorResponse,
    BusinessModel,
    OrderDelivery,
    OrderState,
    OrderType,
    PaymentType,
    Shop,
    Table
} from '@us/web/shared/data-access';
import { Cart, CartFillable, CartItem } from './cart.reducer';

export const CartActions = createActionGroup({
    source: 'Cart',
    events: {
        'Add To Cart': props<{ item: CartItem; redirectUrl?: string }>(),
        'Add To Cart Success': props<{ item: CartItem; shop?: Shop; orderType?: OrderType | null; table?: Table }>(),
        'Add To Cart Failed': emptyProps(),
        'Remove From Cart': props<{ item: CartItem | { uuid: string } }>(),
        'Clear Cart': props<{ item?: CartItem; shop?: Shop }>(),
        'Update Cart': props<CartFillable>(),
        'Update Item Quantity': props<{ item: CartItem; quantity: number }>(),
        'Change Delivery Service': props<OrderDelivery>(),
        'Submit Cart': props<{ businessModel?: BusinessModel; delivery?: OrderDelivery, payment_type?: PaymentType }>(),
        'Submit Cart Success': props<{ cart: Cart; businessModel?: BusinessModel }>(),
        'Submit Cart Failed': props<{ error: string | null }>(),
        'Reset Cart State': emptyProps(),
        'Push Order State': props<{ new_state: OrderState }>(),
        'Push Order State Success': props<{ order: Cart }>(),
        'Push Order State Failed': props<{ error: string | null }>(),
        'Select Table': props<{ tableId: number; shopId?: string }>(),
        'Select Table Success': props<{ table: Table }>(),
        'Select Table Failed': props<{ error: ApiErrorResponse }>(),
        'Update Cart With Promotion': props<CartFillable>()
    }
});
